module.exports = __webpack_public_path__ + "img/3.7a4c7767.jpg";